const userKeys = {
  all: ["user"] as const,
  stakes: () => [...userKeys.all, "stakes"] as const,
  vaultPosition: () => [...userKeys.all, "vault-position"] as const,
  waitForBitcoinDepositTransaction: () =>
    [...userKeys.all, "wait-for-bitcoin-deposit-transaction"] as const,
  confirmCreatedDeposit: () =>
    [...userKeys.all, "confirm-created-deposit"] as const,
  mats: () => [...userKeys.all, "mats"] as const,
  bridgingHistory: () => [...userKeys.all, "bridging-history"] as const,
}

const mezoKeys = {
  all: ["mezo"] as const,
  stakingStats: () => [...mezoKeys.all, "staking-stats"] as const,
  vaultStats: () => [...mezoKeys.all, "vault-stats"] as const,
  mezoVaultsStats: () => [...mezoKeys.all, "mezo-vault-stats"] as const,
  productDetails: () => [...mezoKeys.all, "market", "product-details"] as const,
  statistics: () => [...mezoKeys.all, "statistics"] as const,
}

export default {
  userKeys,
  mezoKeys,
}
